import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';

import { Container, Row, Button } from 'reactstrap';

//_Partials
import Header from "../../_partials/Header/Header";
import Sidebar from "../../_partials/Sidebar/Sidebar";

class Registrations extends Component {

    constructor(props){
        super(props);
        this.state = {
            registrations: "",
            events: []
        }

        this.deleteRegister = this.deleteRegister.bind(this);
    }

    deleteRegister = (regID) => {
        var record = JSON.parse(localStorage.getItem("key"));
        var token = record.token;
        axios({
            method: 'delete',
            url: '/registration/' + regID,
            headers : {
                "x-access-token" : token
            }
        })
        .then(res => {
          if (res.status === 200) {

            this.setState({deleteMsg: res.data});

            axios({
                url: '/registrations',
                method:'get',
                headers : {
                    "x-access-token" : token
                }
            })
            .then(res => {
                this.setState({ registrations: res.data });
            })

          }
        })
    }

    tableRegistrations = (data) => {
        let table = []
        console.log('Events', this.state.events);
        for (let i = 0; i < data.length; i++) {

            let children = [];

            children.push(<td key="certification">{data[i].certification}</td>)
            const event = this.state.events.find((e) => e.id === Number.parseInt(data[i].event));
            if(event){
              children.push(
                <td key="event">
                    Title: {event.title}<br></br>
                    Date: {moment(event.date).format('YYYY-MM-DD')}<br></br>
                    Time: {moment(event.start_time).format("HH:mm") + " - " + moment(event.end_time).format("HH:mm") }
                </td>
              )
            } else {
              children.push(<td key="event"></td>)
            }
            children.push(<td key="name">{data[i].firstname} {data[i].lastname}</td>)
            children.push(<td key="phone">{data[i].phone}</td>)
            children.push(<td key="at">{moment(data[i].created_at).add(1, 'hour').format('YYYY-MM-DD HH:mm')}</td>)
            children.push(<td key="action"><a href={"/admin/registration/edit/" + data[i].id} className="btn btn-primary btn-sm">Edit</a> <Button color="danger" size="sm" onClick={ () => { if (window.confirm('Are you sure you wish to delete this registration?')) this.deleteRegister(data[i].id) } }>Delete</Button></td>)

            table.push(<tr key={"row"+i}>{children}</tr>)

        }
        return table;
    }

    componentDidMount() {
        var record = JSON.parse(localStorage.getItem("key"));
        var token = record.token;
        axios({
            url: '/registrations',
            method:'get',
            headers : {
                "x-access-token" : token
            }
        }).then(res => {
            this.setState({ registrations: res.data });
        })
        axios({
          url: '/events',
          method:'get',
        }).then(res => {
          this.setState({ events: res.data });
        })
    }

    render() {
        return (
        <div className="AdminRegistrations">
            <Header />
            <Container fluid>
                <Row>
                    <Sidebar />
                    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
                        <h2>User Registrations</h2>
                        <div className="table-responsive">
                            <table className="table table-striped table-sm" style={{ color: 'white' }}>
                            <thead>
                                <tr>
                                    <th>Certification</th>
                                    <th>Event</th>
                                    <th>Name</th>
                                    <th>Phone</th>
                                    <th>Registered At</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.tableRegistrations(this.state.registrations)}
                            </tbody>
                            </table>
                        </div>
                    </main>
                </Row>
            </Container>
        </div>
        );
    }
}
export default Registrations;
